export default __webpack_public_path__ + "static/omah-q-wo-d485dc3874f41c1775c1ec423359f530.png";